/*
 * Types.
 */

export type NonEmptyArray<T> = [T, ...ReadonlyArray<T>];

export function isNonEmptyArray<T>(array: ReadonlyArray<T>): array is NonEmptyArray<T> {
  return array.length > 0;
}
